import { apiRequest } from "./api.client";

interface GenerateQRResponse {
  token_id: string;
  token: string;
  qr_image: string;
  expires_at: string;
}

export const AbdmAPI = {
  generateQR: (): Promise<GenerateQRResponse> =>
    apiRequest<GenerateQRResponse>("/abdm/link/generate-qr", { method: "POST" }),
};
